import { render, staticRenderFns } from "./SchoolJob.vue?vue&type=template&id=004e4b1e&scoped=true"
import script from "./SchoolJob.vue?vue&type=script&lang=js"
export * from "./SchoolJob.vue?vue&type=script&lang=js"
import style0 from "./SchoolJob.vue?vue&type=style&index=0&id=004e4b1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004e4b1e",
  null
  
)

export default component.exports